<template>
    <router-link :to="articleParams" class="custom-ArticleNavigationLink ArticleNavigationLink ArticleNavigationLink_next" v-if="articleParams !== null">
        <header class="custom-ArticleNavigationLink-title ArticleNavigationLink-title ArticleNavigationLink-title_next">
            <span>Next article</span>
            <iconNext class="custom-ArticleNavigationLink-icon ArticleNavigationLink-icon" />
        </header>
        <article class="custom-ArticleNavigationArticle ArticleNavigationArticle ArticleNavigationArticle_next">
            <figure class="ArticleNavigationArticle-media ArticleNavigationArticle-media_next" v-if="articleToGo.preview.image || articleToGo.preview.video">
                <img :src="articleToGo.preview.image.url" class="ArticleNavigationArticle-image" v-if="articleToGo.preview.image && !articleToGo.preview.video">
                <img :src="videoThumb" class="ArticleNavigationArticle-video" v-if="articleToGo.preview.video">
            </figure>
            <header class="custom-ArticleNavigation-header ArticleNavigation-header ArticleNavigationHeader">
                <h2 class="custom-ArticleNavigation-title ArticleNavigation-title" v-if="articleToGo.title">{{articleToGo.title}}</h2>
                <h3 class="custom-ArticleNavigation-subtitle ArticleNavigation-subtitle" v-if="articleToGo.subtitle">{{articleToGo.subtitle}}</h3>
            </header>
        </article>
    </router-link>
</template>

<script>
    import store from '@/store';
    import iconNext from '@/icons/caret-right.svg';

    export default {
        name: 'ArticleNavNext',
        components: {
            iconNext
        },
        mounted() {
            this.eventInit();
        },
        computed: {
            articleToGo() {
                if (store.state.currentArticleIndex < store.state.articlesFullList.length - 1) {
                    return store.state.articlesFullList[store.state.currentArticleIndex + 1];
                }
                return null;
            },
            articleParams() {
                return (this.articleToGo !== null) ? {
                    name: 'article',
                    params: {
                        slug: this.articleToGo.slug
                    }
                } : null;
            },
            videoThumb() {
                if (this.articleToGo.preview.video) {
                    const highRes = this.articleToGo.preview.video.urls.raw;
                    const fallback = this.articleToGo.preview.video.urls.thumb;
                    const img = new Image();
                    img.src = highRes;
                    return (img.naturalWidth > 120)?highRes:fallback;
                }
            }
        },
        watch: {
            '$route.params': function () {
                this.eventInit();
            }
        },
        methods: {
            eventOver: (el, className) => {
                el.classList.add(className);
            },
            eventOut: (el, className) => {
                el.classList.remove(className);
            },
            eventInit() {
                let vm = this;
                document.querySelectorAll('.custom-ArticleNavigationLink-title').forEach((el) => {
                    el.parentElement.addEventListener('mouseover', function () {
                        vm.eventOver(el.parentElement, 'custom-ArticleNavigationLink_hover', 'ArticleNavigationLink_hover');
                        vm.eventOver(el, 'custom-ArticleNavigationLink-title_hover', 'ArticleNavigationLink-title_hover');
                        vm.eventOver(el.getElementsByTagName('svg')[0], 'custom-ArticleNavigationLink-icon_hover', 'custom-ArticleNavigationLink-icon_hover');
                    });
                    el.parentElement.addEventListener('mousemove', function () {
                        vm.eventOver(el.parentElement, 'custom-ArticleNavigationLink_hover', 'ArticleNavigationLink_hover');
                        vm.eventOver(el, 'custom-ArticleNavigationLink-title_hover', 'ArticleNavigationLink-title_hover');
                        vm.eventOver(el.getElementsByTagName('svg')[0], 'custom-ArticleNavigationLink-icon_hover', 'custom-ArticleNavigationLink-icon_hover');
                    });
                    el.parentElement.addEventListener('mouseout', function () {
                        vm.eventOut(el.parentElement, 'custom-ArticleNavigationLink_hover', 'ArticleNavigationLink_hover');
                        vm.eventOut(el, 'custom-ArticleNavigationLink-title_hover', 'ArticleNavigationLink-title_hover');
                        vm.eventOut(el.getElementsByTagName('svg')[0], 'custom-ArticleNavigationLink-icon_hover', 'custom-ArticleNavigationLink-icon_hover');
                    });
                });
            }
        }
    };
</script>
